import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';


@Component({
    selector: 'app-modal-title',
    templateUrl: './modal-title.component.html',
    styleUrls: ['./modal-title.component.css'],
    standalone: false
})
export class ModalTitleComponent implements OnInit {

  @Input() title: string = 'default.title'; // Default translation key
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  ngOnInit(): void {
  }

}
